const routes = {
  login: "/login",
  home: "/home",
  rules: "/rules",
  addrule: "/addRule"
};

export default routes;